module.exports = __webpack_public_path__ + "static/media/infiniteWhite.2f1ce711.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/ambassador/infiniteWhite.png
// module id = 590
// module chunks = 0